// eslint-disable-next-line no-unused-vars
import React, { useCallback, useState } from 'react'
import { Box, Dialog, DialogContent, Divider } from '@material-ui/core'

import AppBar from './AppBar'
import ButtonPosition from './ButtonPosition'

import SearchAddress from '~/components/Autocomplete/SearchAddress'
import { useLiterals } from '~/components/Literals'

import { compartilharEndereco, digitarEndereco } from '~/track'

export default function Mobile({ open, onClose, onChangeLocation }) {
  const { getLiteral } = useLiterals()

  const [isExistsValue, setIsExistsValue] = useState(false)

  const onChangeValue = useCallback((value) => setIsExistsValue(value), [])

  return (
    <Dialog open={open} fullScreen={true} disableAutoFocus>
      <AppBar title={getLiteral('2683')} onClose={onClose} />
      <DialogContent style={{ padding: '8px 16px' }}>
        <SearchAddress
          onChangeLocation={(location) => {
            digitarEndereco() // track
            onChangeLocation(location)
          }}
          onChangeValue={onChangeValue}
          placeholder={getLiteral('3316')}
        />
        <Divider style={{ margin: '20px 10px 0' }} />
        {!isExistsValue ? (
          <Box style={{ padding: 18 }}>
            <ButtonPosition
              onChangeLocation={(location) => {
                compartilharEndereco(location) // track
                onChangeLocation(location)
              }}
            />
          </Box>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}
